'use strict';

(function () {
    'use strict';

    analyticsService.$inject = ['$http', 'appConfig', 'baseService'];
    angular.module('app.services').factory('analyticsService', analyticsService);

    function analyticsService($http, appConfig, baseService) {
        'ngInject';

        var service = {
            getDeviceAlerts: getDeviceAlerts,
            getAlertsCount: getAlertsCount,
            getAlertLevels: getAlertLevels,
            getAlertGroups: getAlertGroups,

            getDeviceAlertsCount: getDeviceAlertsCount
        };

        return service;

        ////////////////

        /**
         * 
         * @param {*} modality 
         * @param {*} device 
         * @param {*} from 
         * @param {*} to 
         */
        function getDeviceAlerts(modality, device, from, to) {
            var apiUrl,
                params = {};

            apiUrl = appConfig.apiUrl + '/' + modality.analytics_table;

            params = {
                select: 'at:windows_start,alert:alerts(id,order,group:alert_groups(id,order))',
                device_id: 'eq.' + device.id,
                order: 'windows_start.asc',
                windows_start: 'gte.' + from.format(),
                windows_end: 'lte.' + to.format()
            };

            return $http.get(apiUrl, {
                transformResponse: $http.defaults.transformResponse.concat(baseService.createDateAttrTransformer('at')),
                params: params
            }).then(function (r) {
                var keyMapper = function keyMapper(o) {
                    return o.at.toString();
                },
                    entryCreator = function entryCreator(date) {
                    return { alert: undefined, at: date };
                },
                    alerts = baseService.fillInMissingEntries(r.data, from, to, 15, 'minutes', keyMapper, entryCreator);

                return { modality: modality, alerts: alerts };
            });
        }

        /**
         *
         */
        function getAlertsCount(from, to) {
            var config = {
                params: {
                    _from: '' + from.format(),
                    _to: '' + to.format()
                },
                cache: true
            };

            return $http.get(appConfig.apiUrl + '/rpc/latest_alerts', config).then(function (r) {
                return r.data;
            });
        }

        /**
         * 
         */
        function getAlertLevels() {
            return $http.get(appConfig.apiUrl + '/alerts').then(function (r) {
                return r.data;
            });
        }

        /**
         * 
         */
        function getAlertGroups() {
            return $http.get(appConfig.apiUrl + '/alert_groups').then(function (r) {
                return r.data;
            });
        }

        /**
         * 
         */
        function getDeviceAlertsCount(id, from, to) {
            var config = {
                params: {
                    _device_id: '' + id,
                    _from: '' + from.format(),
                    _to: '' + to.format()
                },
                cache: true
            };

            return $http.get(appConfig.apiUrl + '/rpc/latest_alerts', config).then(function (r) {
                return _(r.data).groupBy('modality_id').mapValues(function (o) {
                    return _.sumBy(o, 'count');
                }).value();
            });
        }
    }
})();